export interface TextQueryFilter {
  field: 'text' | 'word';
  negated: false;
  name: string;
  input: string;
  value: string;
}

export interface TextQueryGroup {
  filters: TextQueryFilter[];
  groups: TextQueryGroup[];
  operator: 'and' | 'or' | 'near';
  slop?: number;
}

function filter(field: 'text' | 'word', value: string): TextQueryFilter {
  return { field, negated: false, name: '', input: value, value };
}

export function buildTextSearchQuery(text: string): TextQueryGroup {
  const words = text.split(' ').filter((word) => word !== '');

  if (words.length < 3) {
    return {
      filters: [],
      groups: [{ filters: [filter('text', text)], groups: [], operator: 'or' }],
      operator: 'and',
    };
  }

  if (words.length === 3) {
    return {
      filters: [],
      groups: [
        {
          filters: [
            filter('text', words.join(' ')),
            filter('text', `${words[0]} ${words[1]}`),
          ],
          groups: [],
          operator: 'or',
        },
      ],
      operator: 'and',
    };
  }

  // 4+ words: full-phrase match OR first word "near" each subsequent word.
  return {
    filters: [],
    groups: [
      { filters: [filter('text', text)], groups: [], operator: 'or' },
      ...words.slice(1).map((word) => ({
        filters: [filter('word', words[0]), filter('word', word)],
        groups: [],
        slop: 5,
        operator: 'near' as const,
      })),
    ],
    operator: 'or',
  };
}
